import React from 'react'

const SvgCalendarWarningOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.946 12.657l-4.815 9.588c-.402.803.17 1.755 1.054 1.755h9.63c.884 0 1.456-.952 1.054-1.755l-4.815-9.588a1.174 1.174 0 00-2.108 0zm-.21 8.99c0-.667.53-1.207 1.184-1.207.654 0 1.184.54 1.184 1.206 0 .666-.53 1.206-1.184 1.206-.654 0-1.184-.54-1.184-1.206zm2.072-6.03c0-.5-.398-.904-.888-.904a.896.896 0 00-.888.904v3.015c0 .5.398.904.888.904s.888-.405.888-.904v-3.015z'
    />
    <path d='M9 18c-.667.001-1-.332-1-1 0-.668.335-1.001 1.002-1H10c.667 0 1 .333 1 1s-.333 1-1 1H9zM9 14c-.667.001-1-.332-1-1 0-.668.335-1.001 1.002-1H10c.667 0 1 .333 1 1s-.333 1-1 1H9zM13 13c0 .668.333 1.001 1 1h.032l1.004-2h-1.034c-.667-.001-1.002.332-1.002 1z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7 4H6c-1.333 0-2 .668-2 2.004V20c0 1.333.667 2 2 2h4.099c.056-.22.137-.439.244-.652L11.019 20H6V10h12a3.188 3.188 0 012 .704V6c0-1.333-.667-2-2-2h-1V2.941C17 2.314 16.667 2 16 2s-1 .314-1 .941V4H9.004V3c0-.667-.334-1-1.004-1-.67 0-1.002.333-1 1v1zM6 8V6h12v2H6z'
    />
  </svg>
)

export default SvgCalendarWarningOutline
